module.exports = __webpack_public_path__ + "static/img/che02.ae74e79.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/che02.png
// module id = 4jJE
// module chunks = 1